import {keys} from 'ts-transformer-keys';

import {
    Images,
    Messages
} from '~/shared/src/utilities/dataExtraction';
import {Query} from '~/shared/src/utilities/query';
import {SelectedViews} from '~/shared/src/utilities/modules/calendar';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


// CFG:Calendar
export type Calendar = {
    data : {
        id : number;
        key : string;
        name : string;

        isEditable? : boolean;
        selectedView? : SelectedViews;
        flexibleSlotTimeLimits? : boolean;
        slotMaxTime? : string;
        slotMinTime? : string;
    };
    query : Query;
    images : Images;
    messages : Messages;
    permissions : GroupPermissions;
};
export const calendarDataProps = keys<Calendar['data']>();
export const calendarProps = keys<Calendar>();
export const requiredCalendarProps = keys<RequiredOf<Calendar>>();
